import { ListParams } from "../models/listParams";
import { OrganizationFilter } from "../models/notification/organizationFilter";
import { MarkReadResponse } from "../models/notification/markRead";
import { NotificationListResponse } from "../models/notification/notification";
import { UnreadCountByCategoryResponse, UnreadCountResponse } from "../models/notification/unreadCount";
import { BaseWebService } from "./base.web.service";

export class NotificationsWebService extends BaseWebService {

  public async getNotifications(organizationId: string, listParams: ListParams): Promise<NotificationListResponse> {
    const params = this.createListParams(listParams);
    const headers = await this.getHeadersJsonForOrganization(organizationId);
    const url = `${this.appConfig.serviceNotificationsUrl}/api/v1/notifications${params}`;
    return this.makeRequest(url, 'GET', headers);
  }

  public async getUnreadCount(organizationId: string): Promise<UnreadCountResponse> {
    const headers = await this.getHeadersJsonForOrganization(organizationId);
    const url = `${this.appConfig.serviceNotificationsUrl}/api/v1/notifications/unread-count`;
    return this.makeRequest(url, 'GET', headers);
  }

  public async getUnreadCountByCategory(organizationId: string): Promise<UnreadCountByCategoryResponse> {
    const headers = await this.getHeadersJsonForOrganization(organizationId);
    const url = `${this.appConfig.serviceNotificationsUrl}/api/v1/notifications/unread-count-by-category`;
    return this.makeRequest(url, 'GET', headers);
  }

  public async getOrganizationFilter(organizationId: string): Promise<OrganizationFilter[]> {
    const headers = await this.getHeadersJsonForOrganization(organizationId);
    const url = `${this.appConfig.serviceNotificationsUrl}/api/v1/notifications/organization-filter`;
    return this.makeRequest(url, 'GET', headers);
  }

  public async markRead(notificationIds: string[], isRead: boolean, organizationId: string): Promise<MarkReadResponse> {
    const headers = await this.getHeadersJsonForOrganization(organizationId);
    const url = `${this.appConfig.serviceNotificationsUrl}/api/v1/notifications/mark-read`;
    const body = { notificationIds, isRead };
    return this.makeRequest(url, 'POST', headers, body);
  }
}
